import React from 'react';
import RescueIDProfile from './components/RescueIDProfile';

function App() {
  return <RescueIDProfile />;
}

export default App;
